export const FINISH_CHECK_DEPOSIT = 'finish-check-deposit';
export const REFRESH_AFTER_INSTANT_DEPOSIT = 'refresh-after-instant-deposit';
export const RELOAD_COMBINED_PROVIDER = 'reload-combined-provider';
